import { TEC_SOPRALLUOGO } from 'constants/ProjectsConstant';
import { GENERIC_TASKS, TECHNICIAN_TASKS } from './CommonTasks';

export const TEC_SOPRALLUOGO_STEPS = [
  {
    code: TEC_SOPRALLUOGO,
    icon: null,
    order: 1,
  },
];

export const TEC_SOPRALLUOGO_TASKS = [...TECHNICIAN_TASKS, ...GENERIC_TASKS];
